// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yPiO","rootNoMargin":"styles_rootNoMargin__HSgvx"};